import { render, staticRenderFns } from "./AfterSalesService.vue?vue&type=template&id=05de1751&scoped=true&"
import script from "./AfterSalesService.vue?vue&type=script&lang=js&"
export * from "./AfterSalesService.vue?vue&type=script&lang=js&"
import style0 from "./AfterSalesService.vue?vue&type=style&index=0&id=05de1751&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de1751",
  null
  
)

export default component.exports